import { createContext } from 'react';

const DEFAULT_STATE = {};

export const AlertContext = createContext(DEFAULT_STATE);
